import { Components, switchClasses, Theme } from "@mui/material";

export const MuiSwitch: Components<Omit<Theme, "MuiSwitch">>["MuiSwitch"] = {
  styleOverrides: {
    root: {
      padding: 0,
      height: 20,

      [`& .${switchClasses.switchBase}.Mui-checked+.${switchClasses.track}`]: {
        backgroundColor: "#262626",
        opacity: 1,
      },

      [`& .${switchClasses.switchBase}.Mui-checked .${switchClasses.thumb}`]: {
        backgroundColor: "#fff",
      },
    },
    sizeSmall: {
      padding: 0,
      [`& .${switchClasses.track}`]: {
        width: 32,
      },
      [`& .${switchClasses.switchBase}`]: {
        padding: 2,
        [`&.${switchClasses.checked}`]: {
          transform: "translateX(12px)",
        },
      },
    },
    switchBase: ({ theme: { palette } }) => ({
      color: palette.common.white,
      padding: 2,
    }),
    track: {
      backgroundColor: "#D9D9D9",
      borderRadius: 12,
      opacity: 1,
      width: 40,
      height: 20,
    },
    thumb: {
      boxShadow: "none",
      width: 16,
      height: 16,
    },
  },
};
